import ApiService from '../api.services';

const BilletService = {
    list: async function () {
        try {
            const response = await ApiService.get('/api/billet');
            return response.data;
        } catch (error) {
            throw error;
        }
    },
    filter: async function (data) {
        try {
            const response = await ApiService.post('/api/billet/list/filter', data);
            return response.data;
        } catch (error) {
            throw error;
        }
    },
    get: async function (id) {
        try {
            const response = await ApiService.get(`/api/billet/${id}`);
            return response.data;
        } catch (error) {
            throw error;
        }
    },
    report: async function (startedAt, finishedAt) {
        try {
            const response = await ApiService.get(`/api/billet/report/csv?startedAt=${startedAt}&finishedAt=${finishedAt}`);
            return response.data;
        } catch (error) {
            throw error;
        }
    },
    add: async function (customerId) {
        try {
            const data = {
                customer: customerId,
            }
            const res = await ApiService.post('/api/billet', data);
            return res.data;
        } catch (error) {
            throw error;
        }
    },
    mybillets: async function (customer) {
        try {
            const response = await ApiService.get(`/api/billet/list/my/${customer}`);
            return response.data;
        } catch (error) {
            throw error;
        }
    },
    mail: async function () {
        try {
            const response = await ApiService.post(`/api/billet/mail`);
            return response.data;
        } catch (error) {
            throw error;
        }
    },
    pdf: async function (id) {
        try {
            const response = await ApiService.get(`/api/billet/pdf/${id}`);
            return response.data;
        } catch (error) {
            throw error;
        }
    },
    payment: async function (id) {
        try {
            const response = await ApiService.patch(`/api/billet/payment/${id}`);
            return response.data;
        } catch (error) {
            throw error;
        }
    },
    delete: async function (id) {
        try {
            const response = await ApiService.delete(`/api/billet/${id}`);
            return response.data;
        } catch (error) {
            throw error;
        }
    },

};

export default BilletService;

export { BilletService };

